import { useState } from 'react';

import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { tracking } from '@iwoca/frontend-tracking-library';
import {
    getAvailableCash,
    getLoanDurationInMonths,
    getMinAvailableCash,
    getTimeOutDate
} from '../../MyOffers.helpers';
import { getMonthsfromDays } from '../../../multiLoanDashboard/accountsSelector';
import { getMaxDate } from '../earlyRepaymentCalculator/EarlyRepaymentHelper';
import { NewApprovedViewUI } from '../NewApprovedView/NewApprovedView';

export const NewChoiceUI = ({
    formalOffers
}: {
    formalOffers: NonNullable<GetFormalOffersResponse['data']>;
}) => {
    const [drawdownAmount, setDrawdownAmount] = useState<number>(
        getMinAvailableCash(formalOffers.formal_offers)
    );
    const [selectedOffer, setSelectedOffer] = useState<
        NonNullable<GetFormalOffersResponse['data']>['formal_offers'][0] | null
    >(null);
    const maxCashAmount = getAvailableCash(formalOffers.formal_offers);
    const timeoutDate = getTimeOutDate(formalOffers.formal_offers);

    let maxDate = new Date().toISOString();
    let loanDuration = 0;

    const updateSelectedOffer = (
        offer:
            | NonNullable<GetFormalOffersResponse['data']>['formal_offers'][0]
            | null
    ) => {
        if (!offer) {
            setSelectedOffer(null);
        } else
            tracking.ampli.formalOfferSelected({
                formal_offer_id: offer.offer_id!,
                duration: getLoanDurationInMonths(offer.duration!)
            });
        setSelectedOffer(offer);
    };

    if (selectedOffer) {
        loanDuration =
            selectedOffer.duration!.unit === 'days'
                ? getMonthsfromDays(selectedOffer.duration!.amount)
                : selectedOffer.duration!.amount;

        maxDate = getMaxDate(selectedOffer.duration?.amount);
    }

    return (
        <NewApprovedViewUI
            loanDuration={loanDuration}
            maxCashAmount={maxCashAmount}
            maxDate={maxDate}
            updateSelectedOffer={updateSelectedOffer}
            timeoutDate={timeoutDate}
            drawdownAmount={drawdownAmount}
            setDrawdownAmount={setDrawdownAmount}
            formalOffers={formalOffers}
            selectedOffer={selectedOffer}
        />
    );
};
